import { render, staticRenderFns } from "./PWR02G04.vue?vue&type=template&id=280d2d5c&scoped=true"
import script from "./PWR02G04.vue?vue&type=script&lang=js"
export * from "./PWR02G04.vue?vue&type=script&lang=js"
import style0 from "./PWR02G04.vue?vue&type=style&index=0&id=280d2d5c&lang=scss&scoped=true"
import style1 from "./PWR02G04.vue?vue&type=style&index=1&id=280d2d5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d2d5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280d2d5c')) {
      api.createRecord('280d2d5c', component.options)
    } else {
      api.reload('280d2d5c', component.options)
    }
    module.hot.accept("./PWR02G04.vue?vue&type=template&id=280d2d5c&scoped=true", function () {
      api.rerender('280d2d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pwr/PWR02G04.vue"
export default component.exports